/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
// @mui
import { Stack, Container, Typography, Card, Box, Button } from '@mui/material';
import TableStyle from '../../ui-component/TableStyle';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { getApi } from 'views/services/api';

const HotelPaymentsDetails = () => {
  const hotelId = JSON.parse(localStorage.getItem('hotelData'))._id;
  
  const [paymentData, setPaymentData] = useState([]);

  const getAllPaymentsDetails = async () => {
    const response = await getApi(`api/payments/list/?createdBy=${hotelId}`);
    console.log(" response ==> ",response);
    if (response && response.status === 200) {
      setPaymentData(response?.data?.paymentsData);
    }
  };

  useEffect(() => {
    getAllPaymentsDetails();
    // eslint-disable-next-line
  }, []);

  const columns = [
    {
      field: '_id',
      headerName: 'S.No.',
      flex: 0.5,
      cellClassName: 'name-column--cell--capitalize',
      valueGetter: (index) => index.api.getRowIndexRelativeToVisibleRows(index.row._id) + 1
    },
    {
      field: 'title',
      headerName: 'Package Name',
      flex: 1,
      cellClassName: 'name-column--cell--capitalize'
    },
    {
      field: 'amount',
      headerName: 'Amount',
      flex: 1,
      cellClassName: 'name-column--cell--capitalize'
    },
    {
      field: 'days',
      headerName: 'Duration',
      flex: 1,
      cellClassName: 'name-column--cell--capitalize',
      renderCell: (params) => {
        return <Box>{params.value} Days</Box>;
      }
    },

    {
      field: 'createdOn',
      headerName: ' Start Date',
      flex: 1,
      valueFormatter: (params) => {
        const date = new Date(params.value);
        const dateOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return date.toLocaleString(undefined, dateOptions);
      }
    },
    {
      field: 'endDate',
      headerName: ' End Date',
      flex: 1,
      valueGetter: (params) => {
        const startDate = new Date(params.row.createdOn);
        const days = parseInt(params.row.days);
        const endDate = new Date(startDate.getTime() + days * 24 * 60 * 60 * 1000);
        const dateOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return endDate.toLocaleString(undefined, dateOptions);
      }
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      renderCell: (params) => {
        let color;
        switch (params.value) {
          case 'active':
            color = 'success';
            break;
          case 'expired':
            color = 'error';
            break;
          case 'expiresSoon':
            color = 'warning';
            break;
          default:
            color = 'inherit';
            break;
        }
        return (
          <Button variant="contained" color={color} sx={{ cursor: 'none' }}>
            {params.value}
          </Button>
        );
      }
    }
  ];

  return (
    <>
      <Container>
        <Stack direction="row" alignItems="center" mb={5} justifyContent={'space-between'}>
          <Typography variant="h4">Payments Details Lists</Typography>
        </Stack>
        <TableStyle>
          <Box width="100%">
            <Card style={{ height: '600px', paddingTop: '15px' }}>
              <DataGrid
                rows={paymentData ?? []}
                columns={columns}
                getRowId={(row) => row._id}
                slots={{ toolbar: GridToolbar }}
                slotProps={{ toolbar: { showQuickFilter: true } }}
              />
            </Card>
          </Box>
        </TableStyle>
      </Container>
    </>
  );
};

export default HotelPaymentsDetails;
